import styled from "@emotion/styled/macro";
import {PropsWithChildren} from "react";

const CheckboxDiv = styled.div`
  display: flex;
  align-items:center;
  gap: 16px;
`
const Checkbox: React.FC<PropsWithChildren<{checked:boolean, onValueChanged: (checked: boolean) => void}>> = (props) => {

    const { checked, onValueChanged } = props;
    return <CheckboxDiv onClick={() => onValueChanged(!checked)}>
        { checked && <img src={"/images/checkbox-checked.svg"} /> }
        { !checked && <img src={"/images/checkbox-unchecked.svg"} /> }
        { props.children }
    </CheckboxDiv>;
}

export default Checkbox;
